import styled from "styled-components";

import { size } from "~/styles/screen";
import { LogoContainer } from "~/templates/network/components/Navbar/styles";

interface Props {
  openMenu: boolean;
}

export const Container = styled.nav<Props>`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  background: ${({ theme }) => theme.colors.darkerGray};
  height: 100vh;
  text-align: left;
  padding: 2rem;
  position: absolute;
  top: 0;
  right: 0;
  transition: transform 0.3s ease-in-out;
  transform: ${(props) => (props.openMenu ? "translateX(0)" : "translateX(100%)")};
  z-index: 5;

  @media screen and (max-width: ${size.small}) {
    width: 100%;
  }

  a {
    font-weight: 700;
    font-family: "Montserrat";
    font-size: 30px;
    line-height: 54.63px;
    color: white;
    text-transform: uppercase;
    text-decoration: none;

    &:hover {
      color: white;
    }
  }
`;

export const LogoContainerMenu = styled(LogoContainer)`
  width: 100px;
  height: unset;
`;
